<template lang="pug">
  nav#navFooter.clearfix
    router-link(
      v-for="(item, index) of nav", 
      :key="index", 
      :to="item.url", 
      :class="{ 'col-6': nav.length == 2, 'col-12': nav.length < 2, 'hl': item.highlight }").bt.col-tp-12
      span {{ item.title }}
      Arrow.icon
</template>

<script>
import './style.sass'
import Arrow from '@/assets/svg/md-arrow-forward.svg'


export default {
  name: 'NavFooter',
  props: {
    nav: Array
  },
  components: {
    Arrow
  }
}
</script>